import logo from "../assets/logo.png";
export default function Header() {
  return (
    <header>
      <nav className="h-24 bg-primary-700 border-b-[2px] border-secondary-main px-24 flex flex-row-reverse justify-between items-center max-[728px]:px-10 text-[32px] max-[450px]:px-4">
        <div className="p-4 w-24 max-[728px]:w-28 rounded-full overflow-hidden">
          <img
            src={logo}
            className="!w-full bg-white rounded-full !h-full"
            alt="main logo"
          />
        </div>
        <h1 className="text-[22pt] max-[900px]:hidden text-[#FFF] dana-l">
          آزمون آنلاین دانا
        </h1>
        {/* <div className="flex flex-row-reverse items-center gap-2"> */}
          {/* <a
            href="https://discord.gg/ruek3yVHuP"
            target="_blank"
            rel="noreferrer"
            className="rounded-[16px] duration-300 group hover:border-secondary-main p-2 border-[3px] border-primary-main max-[728px]:rounded-[12px]"
          >
            <FaDiscord className="duration-300 group-hover:text-primary-600 text-[32px] max-[728px]:text-[20px]" />
          </a>
          <a
            href="https://twitter.com/aliprice1999"
            target="_blank"
            rel="noreferrer"
            className="rounded-[16px] duration-300 group hover:border-secondary-main p-2 border-[3px] border-primary-main max-[728px]:rounded-[12px]"
          >
            <RiTwitterXFill className="duration-300 group-hover:text-primary-600 text-[32px] max-[728px]:text-[20px]" />
          </a>

          <a
            href="https://instagram.com/ali_gheymat"
            target="_blank"
            rel="noreferrer"
            className="rounded-[14px] aspect-square duration-300 group hover:border-secondary-main p-2 border-[3px] border-primary-main max-[728px]:rounded-[12px]"
          >
            <FaInstagram className="duration-300 group-hover:text-primary-600 text-[32px] max-[728px]:text-[20px]" />
          </a> */}
        {/* </div> */}
      </nav>
    </header>
  );
}
